import React from 'react';
// Importar o logo SVG
import LogoMDS  from '../logo_40_anos_mds_white.svg';

// Definição da interface para os dados dos cards para melhor tipagem
interface CardInfo {
  id: number;
  buttonText: string;
  link: string;
  description: string;
  phase: string;
}

const cardData: CardInfo[] = [
  {
    id: 1,
    buttonText: "Panorama Competitivo",
    link: "https://mds-obs.pariisma.com/",
    description: "Painel interativo para análise de desempenho e transformação digital",
    phase: "Prova de Conceito",
  },
  {
    id: 2,
    buttonText: "Análise de Corretores",
    link: "https://mds-obs-fin.pariisma.com/",
    description: "Análise comparativa dos principais corretores de seguros em Portugal (2021-2023)",
    phase: "Prova de Conceito",
  },
  {
    id: 3,
    buttonText: "MDS vs Sabseg",
    link: "https://mds-vs-sabseg.pariisma.com/", 
    description: "Análise Financeira comparativa",
    phase: "Protótipo",
  },
];

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* Header */}
      <header className="bg-[#03194f] text-white shadow-lg">
        <div className="container mx-auto px-6 py-8 flex items-center">
          <div className="w-32 sm:w-48 h-auto flex flex-wrap items-center justify-center">
            <img src={LogoMDS} alt="MDS Logo" className="" />
          </div>
          <div className='sm:px-12'>
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight">Observatório da Concorrência</h1>
            <h2 className="text-lg md:text-xl text-slate-300">Aplicações em desenvolvimento</h2>
          </div>
        </div>
      </header>

      {/* Corpo da Página com Cards */}
      <main className="flex-grow container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cardData.map((card) => (
            <div
              key={card.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col transition-all duration-300 hover:shadow-2xl"
            >
              <div className="p-6 flex flex-col flex-grow">
                <a
                  href={card.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-[#1032CF] hover:bg-black text-white font-semibold py-3 px-4 rounded-md text-center text-lg transition duration-150 ease-in-out mb-5 block"
                >
                  {card.buttonText}
                </a>
                <p className="text-gray-700 text-base mb-4 flex-grow">
                  {card.description}
                </p>
                <p className="text-sm text-gray-500 italic mt-auto pt-2 border-t border-gray-200">
                  Fase: {card.phase}
                </p>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* Footer (Opcional, mas bom para completar a página) */}
      <footer className="bg-[#03194f] text-slate-400 text-center p-4">
        <p>© {new Date().getFullYear()} Observatório da Concorrência MDS.</p>
      </footer>
    </div>
  );
};

export default LandingPage;